<nav class="side-menu {{viewType}}" [class.open]="toggled" [class.collapsed]="isCollapsed"
  [class.collapse-done]="isCollapseDone" [class.light-bg]="selectedType == navTypes.WIZARD"
  [class.grey-bg]="selectedType == navTypes.CONFIG">

  <header *ngIf="selectedType != navTypes.CONFIG && selectedType !=  navTypes.WIZARD">
    <a routerLink="/">
      <app-logo white class="logo"></app-logo>
      <app-icon white class="icon"></app-icon>
    </a>
    <a *ngIf="selectedType == navTypes.MENU" class="btn-toggle" (click)="collapse()">
      <fa-icon [icon]="icons.back"></fa-icon>
    </a>
  </header>

  <header class="config" *ngIf="selectedType == navTypes.CONFIG">
    <a class="btn-back" (click)="goBack()">
      <fa-icon [icon]="icons.back"></fa-icon>
    </a>
    <a routerLink="/">
      <app-logo secondary class="logo"></app-logo>
      <app-icon secondary class="icon"></app-icon>
    </a>
    <strong>Settings</strong>
  </header>

  <ul *ngIf="selectedType == navTypes.MENU" class="menu-list">
    <li [attr.data-test]="menuItem.name" *ngFor="let menuItem of menuItems" [class.hidden]="false"
      routerLinkActive="active" [routerLinkActiveOptions]="menuItem.match || { exact: false }">
      <a [routerLink]="[menuItem.url]" tooltip="{{menuItem.name}}" placement="right">
        <fa-icon *ngIf="menuItem.icon" [icon]="menuItem.icon"></fa-icon>
        <span>{{menuItem.name}}</span>
      </a>
    </li>
  </ul>

  <ul *ngIf="selectedType == navTypes.CONFIG" class="menu-list">
    <li [attr.data-test]="menuItem.name" *ngFor="let menuItem of menuItems" [class.hidden]="false"
      routerLinkActive="active" [routerLinkActiveOptions]="menuItem.match || { exact: true }">
      <a [routerLink]="[menuItem.url]" tooltip="{{menuItem.name}}" placement="right">
        <fa-icon *ngIf="menuItem.icon" [icon]="menuItem.icon"></fa-icon>
        <span>{{menuItem.name}}</span>
      </a>
    </li>
  </ul>

  <ul *ngIf="selectedType == navTypes.WIZARD" class="wizard-list">
    <li [attr.data-test]="step.name" *ngFor="let step of wizardSteps | reverse; let i = index"
      [class.active]="step.name == active">
      <a>
        <span class="indicator check">
          <fa-icon [icon]="icons.check"></fa-icon>
        </span>
        <span class="indicator number">{{(wizardSteps.length - i)}}</span>
        <div>
          <label tooltip="{{step.description}}" placement="right">{{step.name}}</label><br>
          <p>{{step.description}}</p>
        </div>
      </a>
    </li>
  </ul>

  <div *ngIf="selectedType == navTypes.MOCKUP" class="mockup-list">
    <img src="/assets/resource/mockup-list.png" />
  </div>

  <footer>
    <span>{{currentYear}} | All rights reserved</span>
    <ng-container *ngIf="viewType==='user'">
      <div class="dropdown dropup" *ngIf="selectedType == navTypes.MENU || selectedType == navTypes.CONFIG">
        <a data-test="side-menu-bottom-dropdown" class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink"
          data-bs-toggle="dropdown" aria-expanded="false">
          <fa-icon [icon]="icons.hdots"></fa-icon>
        </a>

        <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <ng-container *ngIf="selectedType != navTypes.CONFIG">
            <li data-test="side-menu-bottom-dropdown-settings"><a class="dropdown-item"
                routerLink="/settings">Settings</a></li>
          </ng-container>
          <ng-container *ngIf="selectedType == navTypes.CONFIG">
            <!--li><a class="dropdown-item" routerLink="/settings">Contact Support</a></li>
          <li><a class="dropdown-item" routerLink="/settings">How To: Videos</a></li-->
          </ng-container>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li data-test="side-menu-bottom-dropdown-get-help"><a class="dropdown-item" href="https://help.clooper.com"
              target="_blank">Get Help</a></li>
          <li data-test="side-menu-bottom-dropdown-visit-website"><a class="dropdown-item" href="https://clooper.com"
              target="_blank">Visit Website</a></li>
        </ul>

      </div>
    </ng-container>
  </footer>
</nav>
